var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAvatarMale = function SvgAvatarMale(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#avatar-male_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "#fff",
    rx: 25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#DEF4FF"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB69F",
    d: "M35.665 19.315s1.77-.215 1.93 1.47-.405 2.98-1.455 3.54c0 0-.225.11-.74.2l.265-5.205zM15.64 19.315s-1.77-.215-1.93 1.47.405 2.98 1.455 3.54c0 0 .225.11.74.2l-.265-5.205z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F49037",
    d: "M1.5 52.365s0-7.07 4.14-8.465 13.495-6.75 13.495-6.75h6.33v15.215z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F49037",
    d: "M49.04 52.365s0-7.07-4.14-8.465-13.395-6.75-13.395-6.75h-6.43v15.215z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB69F",
    d: "m20.71 32.26-.585 4.89h10.29l-.64-4.89z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB69F",
    d: "M25.27 40.076c2.842 0 5.145-1.001 5.145-2.236 0-1.234-2.303-2.235-5.145-2.235s-5.145 1.001-5.145 2.236c0 1.234 2.303 2.234 5.145 2.234"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F98",
    d: "M20.32 35.53s7.025.645 9.5-2.435v-3.54l-8.905.855z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB69F",
    d: "M25.69 33.68c5.664 0 10.255-5.87 10.255-13.11S31.354 7.46 25.69 7.46s-10.255 5.87-10.255 13.11 4.591 13.11 10.255 13.11"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B54D4D",
    d: "M34.645 10.1s.01-.025 0-.04c-.34-.815-.755-4.91-7.425-5.53-1.71-.16-4.155.125-5.705.865-2.125 1.01-4.5 1.59-6.6 1.585-.09 0-.125.12-.045.165l1.64 1.305c.065.035.06.13-.01.16l-2.06.625c-.075.03-.075.14 0 .165.335.11 1.185.485 1.955.75-1.26 2.23-.97 5.435-.97 9.285 0 0-.04 3.99 1.305 8.565 1.47 5 4.695 7.145 9.24 7.16 4.84.02 7.365-4.13 8.04-5.605 1.03-2.26 1.915-6.46 1.92-8.985 0 0 1.86-6.38-1.295-10.47zm-4.11 18.525c-1 .51-.495-2.145-2.485-2.255-.665-.04-2.925-.195-4.825-.035-1.445.125-1.795 1.425-1.86 2.085-.03.285-.13.415-.4.315-.6-.22-1.875-.93-2.475-1.59-.62-.68-1.74-2.515-1.845-6.39l.11-5.535s2.225-1.865 2.61-3.19c0 0 9.94 1.59 12.82 0 0 0 1.205 2.305 2.52 3 .405.21.335 2.84.3 4.655a9 9 0 0 0-.08.855c-.265 5.185-3.4 7.58-4.395 8.09z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#441D39",
    d: "M30.535 21.62c.334 0 .605-.47.605-1.05s-.27-1.05-.605-1.05-.605.47-.605 1.05.271 1.05.605 1.05M21.46 21.405c.334 0 .605-.47.605-1.05s-.27-1.05-.605-1.05-.605.47-.605 1.05.27 1.05.605 1.05"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F98",
    d: "M26.395 25.29h-.955c-.425 0-.8-.165-1-.44a.71.71 0 0 1-.115-.65c.215-.69.495-3.265.495-3.29a.245.245 0 0 1 .275-.22c.135.015.235.14.22.275-.01.11-.29 2.645-.515 3.385-.02.075-.01.14.04.21.105.14.34.235.6.235h.955c.14 0 .25.11.25.25s-.11.25-.25.25zM31.065 23.265c.964 0 1.745-.18 1.745-.4s-.781-.4-1.745-.4-1.745.179-1.745.4c0 .22.781.4 1.745.4M20.88 23.265c.963 0 1.745-.18 1.745-.4s-.782-.4-1.745-.4-1.745.179-1.745.4c0 .22.781.4 1.745.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B54D4D",
    d: "M32.655 18.13c-1.665-.49-2.94-.18-3.715-.08-.33.04-.4-.365-.4-.365-.065-.275.305-.465.565-.515.875-.16 1.995-.24 3.655.335.32.11.34.38.34.38-.035.3-.225.305-.445.24zM19.25 18.16c1.655-.52 2.935-.23 3.71-.145.33.035.395-.37.395-.37.06-.275-.315-.46-.575-.505-.88-.145-2-.21-3.645.395-.32.115-.335.385-.335.385.04.3.23.3.445.235z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9B3D3D",
    d: "M25.635 29.35c-1.18 0-2.12-.25-2.18-.265a.248.248 0 1 1 .13-.48c.025.005 2.325.615 4.18-.11.13-.05.275.015.325.14a.253.253 0 0 1-.14.325c-.765.3-1.585.395-2.31.395z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFA242",
    d: "m20.345 35.555 3.98 2.84-1.925 4.61-5.15-4.795z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F49037",
    d: "m24.325 38.395.24 1.705-.905-.115zM26.595 38.305l-.35 1.795.98-.165z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFA242",
    d: "m26.595 38.305 3.645-2.675 3.415 2.74-5.08 5.075z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M26.24 40.755h-1.675V52.36h1.675z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB69F",
    d: "m24.53 39.86.035 1.02s.78.34 1.675 0l.025-.925-1.74-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D6D6D6",
    d: "M26.24 43.205h-1.675v.5h1.675zM26.24 45.46h-1.675v.5h1.675zM26.24 47.715h-1.675v.5h1.675zM26.24 49.97h-1.675v.5h1.675z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFA242",
    d: "M27.665 45.945a.44.44 0 1 0 0-.88.44.44 0 0 0 0 .88M27.665 50.855a.44.44 0 1 0 0-.88.44.44 0 0 0 0 .88"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "avatar-male_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "#fff",
    rx: 25
  })))));
};
export default SvgAvatarMale;